<template>
  <div class="row">
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Rekening Bank</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                      <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-filter" aria-hidden="true"></i> Filter<span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu p-2" >
                        <span>Company:</span>
                        <div class="dropdown-divider"></div>
                        <li v-for="ct in companyList" :key="ct.id">
                          <a href="#" class="small" tabIndex="-1">
                            <input type="checkbox" :value="ct.company_no" v-model="filterCompany"/>&nbsp; {{ ct.name }}
                          </a>
                        </li>
                      </ul>
                      <button type="button" class="btn btn-sm btn-soft-primary" data-toggle="modal" data-target="#modalLedgerBank" data-backdrop="static" data-keyboard="false" @click="setLedgerData"><i class="fa fa-plus" aria-hidden="true"></i> New</button>
                      <button type="button" class="btn btn-sm btn-soft-primary" @click="importLedger"><i class="fa fa-plus" aria-hidden="true"></i> Import</button>
                      <button type="button" class="btn btn-sm  btn-soft-primary waves-light waves-effect" @click="refreshList"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                      <select class="form-control" v-model="bank_id">
                        <option v-for="b in bankList" :key="b.id" :value="b.id">{{ b.name }} - {{ b.account_no }}</option>
                      </select>
                      rows:
                      <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                        <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                      </select>
                      <span class="mr-1">
                        Total rows: <b>{{ rowsTotal }}</b>
                      </span>
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">
                    page:
                    <select v-model="currentPage">
                      <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                    </select>
                    / {{ pageLength }}
                  </span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm">
                    <thead>
                        <tr>
                          <th></th>
                          <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                            {{ t.name }}
                            <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="d in filterData" :key="d.id" style="cursor: pointer" @click="edit(d.id)">
                        <td>
                          <label class="form-checkbox"><input type="checkbox" :value="d.id" v-model="selected"><i class="form-icon"></i></label>
                        </td>
                        <td>{{ d.id }}</td>
                        <td>{{ d.date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ d.notes }}</td>
                        <td class="text-right">{{ d.debit | currency }}</td>
                        <td class="text-right">{{ d.credit | currency }}</td>
                        <td class="text-right">{{ d.saldo | currency }}</td>
                      </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
      <LedgerBankModal :ledger="ledger" @save="saveLedger"/>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { getHeader, ledgerUrl } from '../../config'
import DatePicker from 'vue2-datepicker'
import LedgerBankModal from '@/components/finance/LedgerBankModal.vue'

export default {
  name: 'LedgerBankList',
  components: {
    Loading,
    DatePicker,
    LedgerBankModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      ledger: {
        id: null,
        bank_id: null,
        date: null,
        notes: null,
        debit: '0',
        credit: '0',
        parent_id: null,
        status: null,
        lock: false,
        template_id: null,
        company_no: null
      },
      bank_id: null,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      filterCompany: [],
      startDate: [date1, date2],
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      title: [{
        name: 'ID',
        prop: 'id',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'date',
        align: 'text-left'
      }, {
        name: 'Notes',
        prop: 'notes',
        align: 'text-left'
      }, {
        name: 'Debit',
        prop: 'debit',
        align: 'text-right'
      }, {
        name: 'Credit',
        prop: 'credit',
        align: 'text-right'
      }, {
        name: 'Saldo',
        prop: 'saldo',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
  },
  methods: {
    importLedger () {
      this.$emit('importLedger')
    },
    setLedgerData () {
      this.ledger = {
        id: null,
        bank_id: null,
        date: new Date().toISOString(),
        notes: null,
        debit: '0',
        credit: '0',
        parent_id: null,
        status: null,
        lock: false,
        template_id: null,
        company_no: this.authUser.company_no
      }
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    async edit (id) {
      await this.$Progress.start()
      this.loader.isLoading = true
      console.log(ledgerUrl + '/' + id)
      axios.get(ledgerUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('editLedger', response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    saveLedger (value) {
      var body = {
        bank_id: value.bank_id,
        date: value.date,
        notes: value.notes,
        debit: value.debit.replace(/\./g, ''),
        credit: value.credit.replace(/\./g, ''),
        parent_id: value.parent_id,
        template_id: value.template_id,
        company_no: value.company_no
      }
      console.log(body)
      axios.post(ledgerUrl, body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = ledgerUrl + '?begin=' + begin + '&end=' + end + '&bank=' + this.bank_id
      console.log(url)
      axios.get(url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.currentPage = 1
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      bankList: state => state.banks.bankList,
      authUser: state => state.users.authUser
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  }
}
</script>
